<template>
  <v-card
    :height="isDesktop ? 350 : 200"
    :href="data.link.url"
    color="grey lighten-1"
    dark
  >
    <v-img
      :src="data.image.data + '&w=450'"
      gradient="rgba(0, 0, 0, .42), rgba(0, 0, 0, .42)"
      height="100%"
    >
      <component :blockProperty="sectionSelected.settings.style" is="cover-category">
        <template slot="title">
          {{ data.title.data }}
        </template>
        <template slot="subtitle">
          {{ data.subtitle.data }}
        </template>
        <template slot="link">
          {{ data.link.data }}
        </template>
      </component>
    </v-img>
  </v-card>
</template>
<script>
  import blockProperties from '@fremcast/section/mixins/blockProperties';

  export default {
    mixins: [
      blockProperties
    ]
  }
</script>
